import { SxProps, Theme } from '@mui/system';
import ThemeConstants from '../../../theme/ThemeConstants';

const classes = {
  rightNavbarContainer: {
    display: 'flex',
    alignItems: 'center',
  },

  availabilitiesButton: {
    '& .MuiButton-root': {
      maxHeight: '30px',
      width: 'max-content',
      paddingLeft: '12px',
      paddingRight: '12px',
    },
    alignSelf: 'center',
    marginRight: '1rem',
  },

  iconLabel: {
    fontSize: '14px',
    fontWeight: 500,
    fontFamily: 'Poppins',
    color: 'common.grey850',
  },

  keyboardIcon: {
    paddingLeft: '12px',
  },

  bottomNavbar: {
    borderTop: '2px solid',
    color: 'common.lightBackgroundColor',
    minHeight: '40px !important',
    paddingLeft: '4px',
    maxHeight: '50px !important',
    justifyContent: 'space-between',
  },

  bottomNavbarItem: {
    justifyContent: 'center',
    alignItems: 'center',
    minWidth: '170px',
    borderRadius: 0,
    borderBottom: '2px solid transparent',
    padding: '12px',
  },

  iconButtonRightBorder: {
    border: '0.5px solid',
    color: 'common.borderInput',
    height: '25px',
  },

  iconButtonGridContainer: {
    display: 'flex',
    alignItems: 'center',
  },

  bottomNavbarItemActive: {
    borderBottomColor: 'primary.main',
  },

  bottomNavbarItemIcon: {
    marginRight: '10px',
    width: '20px',
    height: '20px',
  },

  navbarMenusContainer: {
    display: 'flex',
  },

  chatButton: {
    minWidth: 'fit-content',
    paddingX: '26px',
  },

  chip: {
    '&:hover': {
      cursor: 'pointer',
    },
    px: 1,
    py: 0.5,
    border: '1px solid',
    borderColor: 'common.counterRed',
    borderRadius: 10,
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'row',
  },
  celebrationText: {
    fontSize: 16,
  },
  chipText: {
    color: 'common.grey850',
    mr: '3px',
    fontWeight: '500',
    fontSize: 13,
  },
  hurryMargin: {
    mr: '3px',
    mt: '1px',
  },
  hurryText: {
    fontSize: 13,
    fontWeight: '500',
    color: ThemeConstants.common.counterRed,
  },
} satisfies Record<string, SxProps<Theme>>;

export default classes;
